import { render, staticRenderFns } from "./FloatingCart.vue?vue&type=template&id=7991d5dc"
import script from "./FloatingCart.vue?vue&type=script&lang=js"
export * from "./FloatingCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports